import { MsalProvider } from '@azure/msal-react';
import { Layout } from '@organisms/Layout';
import { initGA, logPageView, msalInstance } from '@utils';
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from 'react-router-dom';
import {
  BeforeYouStart,
  IssueType,
  IssueDetails,
  IssueDateTime,
  PhotoUpload,
  IssueLocation,
  Confirmation,
  EmailConfirmationReport,
  ContactUserOption,
  YourDetails,
} from './components/pages';
import { RoutesList, steps } from './routes/Routes';
import { basename } from './routes/basename';
import { InternalServerErrorTemplate, NotFoundErrorTemplate } from '@templates';
import { useEffect } from 'react';
import { useScrollToTop } from '@shared/hooks';

function App() {
  useEffect(() => {
    initGA();
    logPageView();

    // Log page views on route change
    const logPageViewOnRouteChange = () => logPageView();
    window.addEventListener('popstate', logPageViewOnRouteChange);

    return () =>
      window.removeEventListener('popstate', logPageViewOnRouteChange);
  }, []);
  // It's important that the Router component is above the pages component because you'll need to use the useHistory hook before rendering MsalProvider
  return (
    <Router basename={basename}>
      <RouteChangeTracker />
      <Pages />
    </Router>
  );
}

function Pages() {
  useScrollToTop();

  return (
    <MsalProvider instance={msalInstance}>
      <Layout steps={steps}>
        <Routes>
          <Route path={RoutesList.BUSKING_HOME} element={<BeforeYouStart />} />
          <Route path={RoutesList.ISSUE_TYPE} element={<IssueType />} />
          <Route path={RoutesList.ISSUE_DETAILS} element={<IssueDetails />} />
          <Route
            path={RoutesList.ISSUE_DATE_TIME}
            element={<IssueDateTime />}
          />
          <Route path={RoutesList.PHOTO_UPLOAD} element={<PhotoUpload />} />
          <Route path={RoutesList.ISSUE_LOCATION} element={<IssueLocation />} />
          <Route path={RoutesList.YOUR_DETAILS} element={<YourDetails />} />
          <Route
            path={RoutesList.EMAIL_CONFIRMATION_REPORT}
            element={<EmailConfirmationReport />}
          />
          <Route
            path={RoutesList.CONTACT_USER_OPTION}
            element={<ContactUserOption />}
          />
          <Route path={RoutesList.CONFIRMATION} element={<Confirmation />} />
          <Route path={RoutesList.CALLBACKS} element={null} />
          <Route
            path={RoutesList.INTERNAL_SERVER_ERROR}
            element={<InternalServerErrorTemplate />}
          />
          <Route
            path={RoutesList.NOT_FOUND}
            element={<NotFoundErrorTemplate />}
          />
        </Routes>
      </Layout>
    </MsalProvider>
  );
}

export const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    logPageView();
  }, [location]);

  return null;
};
export default App;
